const SESSION_KEY='sgauth.admin.session'
const pageOrigin=typeof window==='undefined'?'http://localhost':window.location.origin
const productionAPI='https://sgapi.anontokyo.jp'
export const resolveAPIBase=(configured:string,hostname:string)=>hostname==='sgadmin.anontokyo.jp'?productionAPI:configured.replace(/\/+$/,'')
export const API_BASE=resolveAPIBase(import.meta.env.VITE_API_BASE_URL||'',new URL(pageOrigin).hostname)
export const ADMIN_OAUTH_ORIGIN=new URL(API_BASE||pageOrigin).origin

export type AdminOAuthMessage={Type:string;ExchangeCode?:string;MatchCode?:string;Success:boolean}
export const readAdminOAuthMessage=(event:Pick<MessageEvent,'origin'|'data'>):AdminOAuthMessage|null=>{
  if(event.origin!==ADMIN_OAUTH_ORIGIN||event.data?.Type!=='sgauth-admin-oauth')return null
  return event.data as AdminOAuthMessage
}

export const auth={
  get:()=>sessionStorage.getItem(SESSION_KEY)||'',
  set:(value:string)=>sessionStorage.setItem(SESSION_KEY,value),
  clear:()=>sessionStorage.removeItem(SESSION_KEY),
}

export class APIError extends Error{
  status:number
  constructor(status:number,message:string){super(message);this.status=status}
}

export type StepUpRequest={path:string;method?:string;body?:unknown}
const stepUpRequestIDs=new Map<string,string>()

const requestBody=(body:unknown)=>body===undefined?'':JSON.stringify(body)
const sha256Hex=async(value:string)=>Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256',new TextEncoder().encode(value)))).map(byte=>byte.toString(16).padStart(2,'0')).join('')

export const startStepUp=async(spec:StepUpRequest,requestID:string)=>{
  const method=(spec.method||'POST').toUpperCase(),path=spec.path.startsWith('/internal/')?spec.path:`/internal${spec.path}`
  return mutate<{challenge_id:string;match_code:string;expires_at:number;delivery_hint:string}>('/auth/step-up/start','POST',{method,path,body_hash:await sha256Hex(requestBody(spec.body))},undefined,requestID)
}

export const verifyStepUp=async(challengeID:string,requestID:string)=>{
  const result=await mutate<{pending?:boolean;token?:string;expires_at?:number}>('/auth/step-up/verify','POST',{challenge_id:challengeID},undefined,requestID)
  if(result.token)stepUpRequestIDs.set(result.token,requestID)
  return result
}

async function request<T>(url:string,init:RequestInit={},authenticated=false):Promise<T>{
  const headers=new Headers(init.headers)
  if(authenticated&&auth.get())headers.set('Authorization',`Bearer ${auth.get()}`)
  if(init.body)headers.set('Content-Type','application/json')
  const response=await fetch(`${API_BASE}${url}`,{...init,headers})
  if(!response.ok){
    let message=`请求失败 (${response.status})`
    try{const body=await response.json();message=body.error||message}catch{/**/}
    throw new APIError(response.status,message)
  }
  if(response.status===204)return undefined as T
  return response.json()
}

export const publicAPI=<T>(path:string,init:RequestInit={})=>request<T>(path,init)
export const api=<T>(path:string,init:RequestInit={})=>request<T>(`/internal${path}`,init,true)
export const mutate=<T>(path:string,method='POST',body?:unknown,stepUpToken?:string,requestID?:string)=>{
  const correlationID=requestID||(stepUpToken?stepUpRequestIDs.get(stepUpToken):undefined)
  if(stepUpToken)stepUpRequestIDs.delete(stepUpToken)
  const headers:Record<string,string>={}
  if(stepUpToken)headers['X-Admin-Step-Up']=stepUpToken
  if(correlationID)headers['X-Request-ID']=correlationID
  return api<T>(path,{method,body:body===undefined?undefined:JSON.stringify(body),headers})
}
export const publicMutate=<T>(path:string,body?:unknown)=>publicAPI<T>(path,{method:'POST',body:body===undefined?undefined:JSON.stringify(body)})
